import { render, staticRenderFns } from "./courseHome.vue?vue&type=template&id=6cdc6954&scoped=true&"
import script from "./courseHome.vue?vue&type=script&lang=js&"
export * from "./courseHome.vue?vue&type=script&lang=js&"
import style0 from "./courseHome.vue?vue&type=style&index=0&id=6cdc6954&prod&lang=css&"
import style1 from "./courseHome.vue?vue&type=style&index=1&id=6cdc6954&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc6954",
  null
  
)

export default component.exports